import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'rotate-clockwise', 'RotateClockwise', [["path",{"d":"M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5","key":"svg-0"}]]);